import React from 'react';
import { H3 } from '../Element/Heading';

interface StateData {
  prices: string;
  growthRank: string;
  topState: string;
  topStateLabel: string;
  growth: string;
  affected: string;
}

interface DataObject {
  [key: string]: StateData;
}

interface StatSectionProps {
  stats: string;
}

const data: DataObject = {
  Arizona: {
    prices: '54%',
    growthRank: '4th',
    topState: '5',
    topStateLabel: 'Arizona is one of the top five states for solar in the U.S',
    growth: 'Growth Projection and Ranking: 10651 MW over the next 5 years',
    affected: '503,113',
  },
  California: {
    prices: '54%',
    growthRank: '2nd',
    topState: '1',
    topStateLabel:
      'California is one of the top two states for solar in the U.S',
    growth: 'Growth Projection and Ranking: 22620 MW over the next 5 years',
    affected: '22,203,596',
  },
  Colorado: {
    prices: '54%',
    growthRank: '13th',
    topState: '13',
    topStateLabel: 'Ranking among the states in the U.S.',
    growth: 'Growth Projection and Ranking: 3778 MW over the next 5 years',
    affected: '2,329,892',
  },
  Connecticut: {
    prices: '54%',
    growthRank: '22nd',
    topState: '39',
    topStateLabel: 'Ranked among the states in the U.S.',
    growth: 'Growth Projection and Ranking: 928 MW over the next 5 years',
    affected: '3,180,301',
  },
  Delaware: {
    prices: '54%',
    growthRank: '39th',
    topState: '43',
    topStateLabel: 'Ranked among the states in the U.S.',
    growth: 'Growth Projection and Ranking: 693 MW over the next 5 years',
    affected: '540,389',
  },
  Florida: {
    prices: '54%',
    growthRank: '3rd',
    topState: '3',
    topStateLabel: 'Ranked among the states in the U.S.',
    growth: 'Growth Projection and Ranking: 12816 MW over the next 5 years',
    affected: '25,348,824',
  },
  Georgia: {
    prices: '54%',
    growthRank: '7th',
    topState: '16',
    topStateLabel:
      'Georgia is one of the top seven states for solar in the U.S',
    growth: 'Growth Projection and Ranking: 3129 MW over the next 5 years',
    affected: '4,930,187',
  },
  Illinois: {
    prices: '54%',
    growthRank: '15th',
    topState: '9',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 6484 MW over the next 5 years',
    affected: '6,222,885',
  },
  Indiana: {
    prices: '54%',
    growthRank: '19th',
    topState: '5',
    topStateLabel:
      'Indiana is one of the top nineteen states for solar in the U.S',
    growth: 'Growth Projection and Ranking: 9774 MW over the next 5 years',
    affected: '2,500,043',
  },
  Iowa: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '1,159,482',
  },
  Kansas: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '784,860',
  },
  Kentucky: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '2,004,924',
  },
  Louisiana: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '3,783,204',
  },
  Maryland: {
    prices: '54%',
    growthRank: '18th',
    topState: '31',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 1643 MW over the next 5 years',
    affected: '4,237,501',
  },
  Maine: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '4,371,598',
  },
  Massachusetts: {
    prices: '54%',
    growthRank: '28th',
    topState: '11',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 1815 MW over the next 5 years',
    affected: '4,355,364',
  },
  Michigan: {
    prices: '54%',
    growthRank: '20th',
    topState: '25',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 2610 MW over the next 5 years',
    affected: '12,489,964',
  },
  Minnesota: {
    prices: '54%',
    growthRank: '32nd',
    topState: '16',
    topStateLabel:
      'Minnesota is one of the top sixteen states for solar in the U.S',
    growth: 'Growth Projection and Ranking: 1612 MW over the next 5 years',
    affected: '2,254,450',
  },

  Missouri: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '2,492,058',
  },
  Mississippi: {
    prices: '54%',
    growthRank: '35th',
    topState: '23',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 2147 MW over the next 5 years',
    affected: '844,023',
  },
  Nevada: {
    prices: '54%',
    growthRank: '8th',
    topState: '6',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 6623 MW over the next 5 years',
    affected: '1,142,085',
  },
  NewHampshire: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '2,811,383',
  },
  NewJersey: {
    prices: '54%',
    growthRank: '22nd',
    topState: '8',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 2246 MW over the next 5 years',
    affected: '5,780,505',
  },
  NewMexico: {
    prices: '54%',
    growthRank: '12th',
    topState: '20',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 4168 MW over the next 5 years',
    affected: '917,411 ',
  },

  NewYork: {
    prices: '54%',
    growthRank: '9th',
    topState: '6',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 8662 MW over the next 5 years',
    affected: '18,359,431',
  },
  NorthCarolina: {
    prices: '54%',
    growthRank: '30th',
    topState: '4',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 1682 MW over the next 5 years',
    affected: '6,033,038',
  },
  Oklahoma: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '2,220,750',
  },
  Ohio: {
    prices: '54%',
    growthRank: '7th',
    topState: '26',
    topStateLabel:
      'Ohio is one of the top twenty-six states for solar in the U.S',
    growth: 'Growth Projection and Ranking: 8057 MW over the next 5 years',
    affected: '7,024,677',
  },
  Oregon: {
    prices: '54%',
    growthRank: '17th',
    topState: '21',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 2831 MW over the next 5 years',
    affected: '3,700,739',
  },
  Pennsylvania: {
    prices: '54%',
    growthRank: '24th',
    topState: '18',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 2806 MW over the next 5 years',
    affected: '7,095,095',
  },
  RhodeIsland: {
    prices: '54%',
    growthRank: '42',
    topState: '32',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 738 MW over the next 5 years',
    affected: '1,161,957',
  },
  SouthCarolina: {
    prices: '54%',
    growthRank: '14th',
    topState: '27',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 2040 MW over the next 5 years',
    affected: '2,479,440',
  },
  Tennessee: {
    prices: '54%',
    growthRank: 'n/a',
    topState: 'n/a',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'n/a',
    affected: '2,520,456',
  },
  Texas: {
    prices: '54%',
    growthRank: '1st',
    topState: '2',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 40787 MW over the next 5 years',
    affected: '11,475,011',
  },
  Utah: {
    prices: '54%',
    growthRank: '12th',
    topState: '19',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 2632 MW over the next 5 years',
    affected: '1,802,762',
  },
  Vermont: {
    prices: '54%',
    growthRank: '37th',
    topState: '50',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 179 MW over the next 5 years',
    affected: '607,749',
  },
  Virginia: {
    prices: '54%',
    growthRank: '10th',
    topState: '10',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 6387 MW over the next 5 years',
    affected: '5,369,718',
  },
  Washington: {
    prices: '54%',
    growthRank: '34th',
    topState: '29',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 1707 MW over the next 5 years',
    affected: '5,627,646',
  },
  WashingtonDC: {
    prices: '54%',
    growthRank: '42nd',
    topState: '49',
    topStateLabel: 'Ranking among the states in the U.S',
    growth: 'Growth Projection and Ranking: 250 MW over the next 5 years',
    affected: '2,532,401',
  },
  Wisconsin: {
    prices: '54%',
    growthRank: '23rd',
    topState: '11',
    topStateLabel:
      'Wisconsin is one of the top twenty-third states for solar in the U.S',
    growth: 'Growth Projection and Ranking: 4630 MW over the next 5 years',
    affected: '2,965,277',
  },
};

const StatSection: React.FC<StatSectionProps> = ({ stats }) => {
  const stateNoSpace = stats.toString().replace(/\s/g, '');
  if (!data[stateNoSpace]) {
    return null; // Handle the case when the state data is not available
  }
  return (
    <section className="bg-gray-100 py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center ">
          <div className="w-full md:w-1/4 px-4 mb-8 md:mb-0 text-center md:text-left">
            <H3 className="font-semibold text-primary text-center md:text-left">
              {data[stateNoSpace].affected}
            </H3>
            <p>
              {stats} residents who experienced power outages in a span of ten
              years¹
            </p>
          </div>
          <div className="w-full md:w-1/4 px-4 mb-8 md:mb-0 text-center md:text-left">
            <H3 className="font-semibold text-primary text-center md:text-left">
              {data[stateNoSpace].prices}
            </H3>
            <p> Prices have fallen 54% over the last 10 years²</p>
          </div>
          <div className="w-full md:w-1/4 px-4 mb-8 md:mb-0 text-center md:text-left">
            <H3 className="font-semibold text-primary text-center md:text-left">
              $1,500+
            </H3>
            <p>
              Average yearly savings for homeowner&apos;s who switch to solar³
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatSection;
